export const OppurtunitySourceValidation = (formData) => {
    const errors = {};

    // Validate each field
    if (!formData.vc_Name.trim()) {
        errors.vc_Name = ' Name is required';
    }

    return errors;
};

